import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-0 w-100 text-center d-flex align-items-center justify-content-center" }
const _hoisted_2 = { key: 0 }

import { computed } from 'vue';
import { usePhieuXuatKhoTableCellApi } from './composables/usePhieuXuatKhoTableCellApi';
import {
  getXuatKhoGroupWidth,
  resolveColumnBindings,
  XUAT_KHO_GROUP_LABEL,
  XUAT_KHO_LEAF_COLUMNS,
  type PhieuXuatKhoXuatKhoLeafColumnId,
} from './composables/usePhieuXuatKhoTableColumns';
import PhieuXuatKhoVatTuCell from './PhieuXuatKhoVatTuCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoVatTuXuatKhoColumns',
  setup(__props) {

const api = usePhieuXuatKhoTableCellApi();
const isSummaryMode = api.isSummaryMode;
const columnContext = computed(() => api.columnContext);
const xuatKhoGroupLabel = XUAT_KHO_GROUP_LABEL;
const xuatKhoLeafIds = XUAT_KHO_LEAF_COLUMNS.map((leaf) => leaf.id);
const groupWidth = computed(() => getXuatKhoGroupWidth(isSummaryMode));

const getLeafBindings = (leafId: PhieuXuatKhoXuatKhoLeafColumnId) =>
  resolveColumnBindings(leafId, columnContext.value, isSummaryMode);

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!

  return (_openBlock(), _createBlock(_component_el_table_column, {
    align: "center",
    fixed: "right",
    "header-align": "center",
    label: _unref(xuatKhoGroupLabel),
    width: groupWidth.value
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(xuatKhoLeafIds), (leafId) => {
        return (_openBlock(), _createBlock(_component_el_table_column, {
          key: leafId,
          align: getLeafBindings(leafId).align,
          "header-align": "center",
          label: _unref(isSummaryMode) ? getLeafBindings(leafId).label : undefined,
          prop: leafId,
          "show-overflow-tooltip": getLeafBindings(leafId).showOverflowTooltip,
          width: getLeafBindings(leafId).width
        }, _createSlots({
          default: _withCtx((scope) => [
            _createVNode(PhieuXuatKhoVatTuCell, {
              "column-id": leafId,
              row: scope.row,
              "row-index": scope.$index
            }, null, 8, ["column-id", "row", "row-index"])
          ]),
          _: 2
        }, [
          (!_unref(isSummaryMode))
            ? {
                name: "header",
                fn: _withCtx(() => [
                  _createElementVNode("p", _hoisted_1, [
                    (getLeafBindings(leafId).pickHeaderBold)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(getLeafBindings(leafId).label), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(getLeafBindings(leafId).label), 1)
                        ], 64))
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["align", "label", "prop", "show-overflow-tooltip", "width"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["label", "width"]))
}
}

})